import styled from 'styled-components';
import tw from 'twin.macro';

export const Container = styled.div.attrs((props) => ({
  className:
    'w-full bg-primary text-white p-4 mb-12 flex justify-between items-center sm:mb-0 sm:px-12 sm:m-auto sm:mt-0 ' +
    props.className,
}))`
  height: 80px;
  background-color: ${(props) => props.bg};

  @media only screen and (max-width: 639px) {
    padding: 25px 30px;
    height: 70px;
  }
`;
export const Content = styled.div.attrs({
  className: 'flex items-center justify-between m-auto',
})`
  max-width: 1440px;
  width: 100%;
`;
export const LogoWrapper = styled.div`
  width: 320px;
  max-height: calc(80px - 2rem);
  overflow: hidden;

  img {
    width: auto;
  }

  @media only screen and (max-width: 639px) {
    // margin-top: 32px;
    // margin-bottom: 24px;
    height: fit-content;

    img {
      width: auto;
      height: 10px;
    }
  }
`;
export const NavItemContainer = styled.div.attrs({
  className: 'flex items-center relative sm:hidden',
})`
  a,
  .header-item,
  .account-item {
    white-space: nowrap;
    cursor: pointer;
  }
  a:not(.menu-item),
  .header-item {
    &:hover {
      text-decoration: underline;
      color: #fff;
    }
    font-size: 14px;
    line-height: 18px;
    padding: 0 36px;
    ${tw`text-white`}
  }
`;
export const MenuContainer = styled.div.attrs({
  className: 'bg-white rounded absolute',
})`
  z-index: 1;
  right: 0;
  top: 2.5rem;
  box-shadow: 0px 2px 7px 1px rgba(0, 0, 0, 0.5);
  padding: 10px 0px;

  .menu-item-wrapper {
    width: 100%;
    padding: 5px 20px;
    cursor: pointer;

    &:hover {
      a.menu-item,
      .account-item {
        color: white;
      }
    }

    a.menu-item,
    .account-item {
      ${tw`text-gray-200`}
      font-weight: normal;
    }

    &:hover {
      background: #0f0c35;
    }
  }

  .divider {
    height: 1px;
    background: #3f3f3f;
    margin: 10px 5px;
  }
`;
